import { PaintedScene } from '../PaintedScene';

export const RIDGE_ABOVE_DONCHITOS_PHASER_KEY = 'RidgeAboveDonchitosScene' as const;
export const RIDGE_ABOVE_DONCHITOS_MANIFEST_KEY = 's-112-ridge-above-donchitos' as const;

export class RidgeAboveDonchitosScene extends PaintedScene {
  constructor() {
    super(RIDGE_ABOVE_DONCHITOS_PHASER_KEY, RIDGE_ABOVE_DONCHITOS_MANIFEST_KEY);
  }
}
